import { DeviceCategoryEnum, type IDevice } from "@multiconsult-group/multiplacer-core";

export const enrichAiDevices = (
  devices: IDevice[],
  standardDevices: IDevice[],
  room: { supplyAirFlow?: number; returnAirFlow?: number }
): IDevice[] => {
  const counts = new Map<string, number>();
  for (const device of devices)
    counts.set(device.deviceCategory, (counts.get(device.deviceCategory) ?? 0) + 1);
  return devices.map((device) => {
    // Already specified products (e.g. copied standard rooms) keep their identity and flows.
    if (device.compCode.trim()) return device;
    const source = standardDevices.find(
      (candidate) => candidate.deviceCategory === device.deviceCategory && candidate.compCode.trim()
    );
    const result = source
      ? { ...device, compCode: source.compCode, description: source.description }
      : { ...device };
    const flowKey =
      device.deviceCategory === DeviceCategoryEnum.SUPPLY_AIR_DEVICE
        ? "supplyAirFlow"
        : device.deviceCategory === DeviceCategoryEnum.RETURN_AIR_DEVICE
          ? "returnAirFlow"
          : undefined;
    if (flowKey && room[flowKey] != null && Number.isFinite(room[flowKey])) {
      // Account for specified devices in a mixed preview without changing them.
      const fixed = devices.filter(
        (d) => d.deviceCategory === device.deviceCategory && d.compCode.trim()
      );
      const remaining = Math.max(
        0,
        room[flowKey]! - fixed.reduce((sum, d) => sum + (d[flowKey] ?? 0), 0)
      );
      result[flowKey] = remaining / (counts.get(device.deviceCategory)! - fixed.length);
    }
    return result;
  });
};
